import { MessageCircle, Phone } from "lucide-react";
import { useState } from "react";
import Reveal from "@/components/Reveal";
import SectionIntro from "@/components/SectionIntro";

const events = ["Birthday", "Anniversary", "Wedding", "Reception", "Corporate gathering", "Other Party"];
const whatsappNumber = "918004080054";

export default function CelebrationSection({ whatsappUrl }) {
  const [event, setEvent] = useState("Birthday");
  const [guests, setGuests] = useState(50);

  const sendPlan = (e) => {
    e.preventDefault();
    const message = `Hello Hashtag Restaurant Varanasi, I would like to plan a ${event.toLowerCase()} for ${guests}+ guests in your garden lawn. Please share the options.`;
    window.open(`${whatsappUrl}?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="editorial-section celebration-section" id="celebrations" aria-labelledby="celebrations-heading">
      <div className="section-inner">
        <Reveal>
          <SectionIntro number="03" kicker="The celebration grounds" title="Make the long table yours." description="Birthdays, anniversaries, wedding functions, and company gatherings all have room to arrive here. The garden lawn can host around 250 people, with private parking to make the welcome easy." />
        </Reveal>
        <div className="celebration-layout">
          <Reveal delay={80}>
            <figure className="celebration-photo">
              <img className="celebration-interior-image" src="/assets/interior/Screenshot 2026-08-31 at 6.51.59 PM.png" alt="Hashtag dining room interior prepared for a celebration" />
              <figcaption className="celebration-caption"><p>Bring your people. We will bring the atmosphere.</p><span>Celebration desk</span></figcaption>
            </figure>
          </Reveal>
          <Reveal delay={160}>
            <div className="celebration-builder" data-testid="celebration-builder">
              <h3>A little planning.<br />A memorable evening.</h3>
              <p>Tell us the shape of your gathering and start the conversation with the Hashtag team on WhatsApp.</p>
              <div className="celebration-stat" data-testid="celebration-capacity-info"><strong>250+</strong><span className="celebration-stat-label">guests<br />on the open lawn</span></div>
              <form className="celebration-form" onSubmit={sendPlan}>
                <label htmlFor="celebration-event">What are we celebrating?
                  <select id="celebration-event" value={event} onChange={(e) => setEvent(e.target.value)} data-testid="celebration-event-type-select">
                    {events.map((item) => <option key={item}>{item}</option>)}
                  </select>
                </label>
                <label htmlFor="celebration-guests">How many guests?
                  <div className="guest-range-row"><input id="celebration-guests" type="range" min="25" max="250" step="25" value={guests} onChange={(e) => setGuests(e.target.value)} data-testid="celebration-guest-slider" /><span className="guest-value" data-testid="celebration-guest-value">{guests}+</span></div>
                </label>
                <button type="submit" className="button button-primary celebration-submit" data-testid="celebration-whatsapp-submit-button"><MessageCircle aria-hidden="true" /> Start on WhatsApp</button>
              </form>
              <div className="celebration-quick-links"><a href={`tel:08004080054`} data-testid="celebration-call-link"><Phone size={14} aria-hidden="true" /> Call the celebration desk</a><a href={`${whatsappUrl}?text=${encodeURIComponent("Hello Hashtag Restaurant, I would like to enquire about a private dining room.")}`} target="_blank" rel="noreferrer" data-testid="celebration-private-dining-link">Private dining room</a></div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
